export default "__VITE_ASSET__ee12329a__"